export default "__VITE_ASSET__CMDNsU92__"